import React from 'react';

const ActiveRouteContext = React.createContext('');

export default ActiveRouteContext;
